import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const TextClassName = `${CLASS_NAME_PREFIX}-text`;
